import React from 'react';
import { ArrowLeft, ArrowRight, Sparkles } from 'lucide-react';

interface QuestionnaireNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  isValid?: boolean;
  isSubmitting?: boolean;
  isLastStep?: boolean;
}

export function QuestionnaireNavigation({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  isValid = true,
  isSubmitting = false,
  isLastStep = false
}: QuestionnaireNavigationProps) {
  return (
    <div className="flex justify-between items-center mt-6 sm:mt-8 gap-3">
      <div className="flex-1">
        {currentStep > 0 && (
          <button
            onClick={onPrevious}
            disabled={isSubmitting}
            className="inline-flex items-center px-4 sm:px-6 py-2.5 sm:py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 text-sm sm:text-base min-h-[44px]"
          >
            <ArrowLeft className="w-4 h-4 mr-1 sm:mr-2" />
            <span className="hidden sm:inline">Previous</span>
            <span className="sm:hidden">Back</span>
          </button>
        )}
      </div>

      <div className="flex-1 flex justify-end">
        <button
          onClick={onNext}
          disabled={isSubmitting || !isValid}
          className={`inline-flex items-center px-4 sm:px-6 py-2.5 sm:py-2 rounded-lg transition-all disabled:opacity-50 text-sm sm:text-base min-h-[44px] ${
            isLastStep
              ? 'bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02]'
              : 'sparkle-button'
          }`}
        >
          {isLastStep ? (
            <>
              <Sparkles className="w-4 h-4 mr-2" />
              Get My Blueprint
            </>
          ) : (
            <>
              Next
              <ArrowRight className="w-4 h-4 ml-1 sm:ml-2" />
            </>
          )}
        </button>
      </div>
    </div>
  );
}